<p class="caption status-danger">
  <ng-content></ng-content>
</p>
